import { $, $$ } from '@zimpa/dom';

export const AUDIO_PLAYER_CONTAINER_SELECTOR = ".js-audio-player__container"
const AUDIO_PLAYER_SELECTOR = 'audio';
const AUDIO_PLAYER_PAUSE_BUTTON_SELECTOR = '.js-audio-player__pause';
const AUDIO_PLAYER_PLAY_BUTTON_SELECTOR = '.js-audio-player__play';
const AUDIO_PLAYER_SLIDER_SELECTOR = '.js-audio-player__slider';
const AUDIO_PLAYER_IMAGE_CONTAINER_SELECTOR = 'figcaption';

const CLASS_HIDE = 'h-hide';

export class AudioPlayer {

    private _isSliding: boolean = false;
    private readonly _player: HTMLAudioElement;
    private readonly _pause: HTMLElement;
    private readonly _play: HTMLElement;
    private readonly _slider: HTMLInputElement;
    private readonly _image_container: HTMLElement;

    public constructor(el: HTMLElement) {

        this._player = <HTMLAudioElement>$(AUDIO_PLAYER_SELECTOR, el);
        this._pause = <HTMLElement>$(AUDIO_PLAYER_PAUSE_BUTTON_SELECTOR, el);
        this._play = <HTMLElement>$(AUDIO_PLAYER_PLAY_BUTTON_SELECTOR, el);
        this._slider = <HTMLInputElement>$(AUDIO_PLAYER_SLIDER_SELECTOR, el);
        this._image_container = <HTMLInputElement>$(AUDIO_PLAYER_IMAGE_CONTAINER_SELECTOR, el);

        this._image_container.style.setProperty('background-image',`url('${this.getImageFromSourceSet('768w')}')`)

        this._pause.classList.add(CLASS_HIDE);

        this.addEventHandlers();
    }

    private getImageFromSourceSet(width:string): string {
        const image = <HTMLImageElement>$('img',this._image_container);
        const srcSet = image.getAttribute('srcset');

        if(srcSet===null) {
            return '';
        }

        const result = srcSet.split(', ').filter((item:string) => {
            const src = item.split(' ');
            return src[1] === width;
        })

        if(result.length>0) {
            return result[0].split(' ')[0];
        }

        return '';
    }

    private addEventHandlers(): void {
        this._play.addEventListener('click', (): void => {
            this.play();
            this._pause.classList.remove('c-player-hidden');
            this._play.classList.add('c-player-hidden');
        });

        this._pause.addEventListener('click', (): void => {
            this.pause();
            this._pause.classList.add('c-player-hidden');
            this._play.classList.remove('c-player-hidden');
        });

        this._player.addEventListener('timeupdate',(e : ProgressEvent) => {
            const pos = 100 * (this._player.currentTime / this._player.duration);

            if(!this._isSliding) {
                this._slider.value = pos.toString();
            }
        })

        this._slider.addEventListener('change',() => {
            const pos = this._player.duration * (parseFloat(this._slider.value)/100);

            this._player.currentTime = pos;
        })

        this._slider.addEventListener('mousedown',() => {
            this._isSliding = true;
        })

        this._slider.addEventListener('mouseup',() => {
            this._isSliding = false;
        })
    }


    public play(): void {
        this._player.play();
        this._play.classList.add(CLASS_HIDE);
        this._pause.classList.remove(CLASS_HIDE);
    }

    public pause(): void {
        this._player.pause();
        this._pause.classList.add(CLASS_HIDE);
        this._play.classList.remove(CLASS_HIDE);
    }

}

export function audioplayer(): void {
    $$(AUDIO_PLAYER_CONTAINER_SELECTOR).forEach((audioplayer: HTMLElement): void => {
        new AudioPlayer(audioplayer);
    });
}

